import { Form } from 'antd';
import { CargoItemInputFieldsSection } from 'components/common/cargo-item-input-fields-section';
import type { ICargoItemFormProps } from './types';

export const CargoItemForm = <TValues,>(props: ICargoItemFormProps<TValues>) => {
  const { form, formId, onFinish, name, withoutStack } = props;

  return (
    <Form form={form} id={formId} layout='vertical' onFinish={onFinish}>
      <CargoItemInputFieldsSection name={name} form={form} withoutStack={withoutStack} />
    </Form>
  );
};
